import { NAME as APP_NAME } from 'constants';
import * as I18n from 'circe/I18n';

import { ROUTES as MANIFEST_ROUTES } from 'domain/manifest/constants';
import { ROUTES as MANIFEST_CREATE_ROUTES } from 'domain/manifest/Create/constants';
import { ROUTES as MASTER_WAYBILLS_ROUTES } from 'domain/manifest/MasterWaybills/constants';

export const NAME = `${APP_NAME}/LAYOUT`;
export const REDUCER_NAME = 'layout';
export const HEADER_HEIGHT = 90;

export const groupMapping = {
  shipping: [
    '/shippers',
    '/shipments',
    '/waybills',,
    '/shipments-assign',
    '/shipment-escalation',
    '/shipment-alerts',
    '/shipment/track',
    '/sheets',
    '/',
    ...Object.values(MASTER_WAYBILLS_ROUTES),
    ...Object.values(MANIFEST_CREATE_ROUTES),
    ...Object.values(MANIFEST_ROUTES),
  ],
  dashboard: ['/dashboard'],
  drivers: ['/drivers', '/tracking'],
  settings: ['/address-book/query', '/cards', '/settings'],
  finance: [
    '/finance',
    '/finance/reconciliation',
    '/finance/credit-terms',
    '/finance/transactions',
    '/finance/invoices',
    '/finance/payables',
  ],
};

export const titleMapping = {
  dashboard: I18n.str('dashboard', 'Dashboard'),
  monthlyDashboard: I18n.str('monthlyDashboard', 'Monthly Dashboard'),

  finance: I18n.str('finance', 'Finance'),
  shipping: I18n.str('shipping', 'Shipping'),
  drivers: I18n.str('drivers', 'Drivers'),
  settings: I18n.str('settings', 'Settings'),
  pulse: I18n.str('pulse', 'Pulse'),
  reconciliation: I18n.str('reconciliation', 'Reconciliation'),
  search: I18n.str('search', 'Search'),
  addresses: I18n.str('addresses', 'Addresses'),
  shippingQuote: I18n.str('shippingQuote', 'Shipping Quote'),
  shipmentsInformation: I18n.str('shipmentsInformation', 'Shipments Information'),
  shipmentsManagement: I18n.str('shipmentsManagement', 'Shipments Management'),
  exworks: I18n.str('exworks', 'ExWork Orders'),
  'dat-orders': I18n.str('datOrders', 'DAT Orders'),
  myShipments: I18n.str('myShipments', 'My Shipments'),
  shipmentHistory: I18n.str('shipmentHistory', 'Shipment History'),
  shipmentsAdministration: I18n.str('shipmentsAdministration', 'Shipments Administration'),
  orders: I18n.str('orders', 'Orders'),
  myOrders: I18n.str('myOrders', 'My Orders'),
  shippers: I18n.str('vendors', 'Vendors'),
  driverEfficiency: I18n.str('driverEfficiency', 'Driver Efficiency'),
  general: I18n.str('general', 'General'),
  cards: I18n.str('cards', 'Cards'),
  companyCode: I18n.str('companyCode', 'Company Code'),
  planningSettings: I18n.str('planningSettings', 'Planning Settings'),
  productTypes: I18n.str('salesCategory', 'Sales Category'),
  zones: I18n.str('zones', 'Zones'),
  shipments: I18n.str('salesOrders', 'Sales Orders'),
  salesOrder: I18n.str('salesOrders', 'Sales Orders'),
  waybills: I18n.str('waybills', 'Waybills'),
  updateShipmentStatus: I18n.str('updateShipmentStatus', 'Update Shipment Status'),
  batchShipments: I18n.str('batchSalesOrders', 'Batch Sales Orders'),
  createShipments: I18n.str('createSalesOrders', 'Create Sales Orders'),
  assignShipments: I18n.str('assignShipments', 'Assign Shipments'),
  shipmentEscalation: I18n.str('shipmentEscalation', 'Shipment Escalation'),
  shipmentAlerts: I18n.str('shipmentAlerts', 'Shipment Alerts'),
  receiveShipments: I18n.str('receiveShipments', 'Receive Shipments'),
  returnShipments: I18n.str('returnShipments', 'Return Shipments'),
  trips: I18n.str('trips', 'Trips'),
  vehicles: I18n.str('vehicles', 'Vehicles'),
  manifest: I18n.str('manifest', 'Manifest'),
  createManifest: I18n.str('createManifest', 'Create Manifest'),
  masterWaybills: I18n.str('masterWaybills', 'Master Waybills'),
  manualAssign: I18n.str('manualAssign', 'Manual Assign'),
  transporters: I18n.str('transporters', 'Transporters'),
  users: I18n.str('users', 'Users'),
  vendorCompanies: I18n.str('vendorCompanies', 'Vendor Companies'),
  factoryFilesUpload: I18n.str('factoryFilesUpload', 'Factory Files Upload'),
};

export const NOTIFICATIONS = {
  key: 'notifications',
  status: {
    read: 'read',
    unread: 'unread',
  },
};
